import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;

    img {
      width: 100%;
      height: 100%;
    }
  `}
`;
